import { defineAsyncComponent } from 'vue'
export default {
  clean: defineAsyncComponent(() => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/layouts/clean.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/Users/utumpornnaikorn/mywork/Niceloop-project2/photowish-production-v2/photowish-present-v2/layouts/default.vue").then(m => m.default || m))
}